module.exports = __webpack_public_path__ + "img/vacations-request-tracker.bcecc6eb.png";